import React from 'react'
import { useValues } from 'kea'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

import AtHomeIcon from '~/scenes/course/show/_assets/at-home-icon.svg'
import AtTeacherIcon from '~/scenes/course/show/_assets/at-teacher-icon.svg'

import courseLogic from '~/scenes/course/show/logic'

const ToggleSwitch = ({ handleClickAtTeacher, handleClickAtHome, atHome, atTeacher }) => {
  const { course } = useValues(courseLogic)

  const { locationInStudio, locationInHouse, locationWebcam } = course

  const inStudioOrWebcamOnly = (locationInStudio || locationWebcam) && !locationInHouse
  const inHouseOnlyLocation = !locationInStudio && !locationWebcam && locationInHouse
  const inStudioOrWebcam = locationInStudio || locationWebcam
  const inStudioOrWebcamOnlyOrInHouseOnly = inStudioOrWebcamOnly || inHouseOnlyLocation

  const isWebcamOnlyLocation = locationWebcam && !locationInStudio
  const isStudioOnlyLocation = !locationWebcam && locationInStudio
  const isStudioAndWebcam = locationWebcam && locationInStudio

  const handleClick = () => {
    if (inStudioOrWebcam && !atTeacher) {
      handleClickAtTeacher()
    } else if (locationInHouse && !atHome) {
      handleClickAtHome()
    }
  }

  const renderLocationLabel = () => {
    if (isStudioAndWebcam) {
      return I18n.t('courses.show.in_studio_webcam')
    }
    if (isWebcamOnlyLocation && !isStudioOnlyLocation) {
      return I18n.t('courses.form.webcam')
    }
    if (!isWebcamOnlyLocation && isStudioOnlyLocation) {
      return I18n.t('courses.show.in_studio')
    }
  }

  return (
    <div
      className={`availability-toggle-switch${
        inStudioOrWebcamOnlyOrInHouseOnly ? ' in-studio-or-webcam-or-in-house-only' : ''
      }`}
      onClick={handleClick}
    >
      {inStudioOrWebcam && (
        <div
          className={`at-teacher-availability-button${atTeacher ? ' active' : ' inactive'}${
            inStudioOrWebcamOnly ? ' in-studio-or-webcam-only' : ''
          }`}
        >
          <div className='at-teacher-availability-icon-text-container'>
            <div className={`at-teacher-availability-icon-container${atTeacher ? ' active' : ' inactive'}`}>
              <img className='at-teacher-icon' alt='at teacher icon' src={`${AtTeacherIcon}`} width={20} height={20} />
            </div>
            <div className={`at-teacher-availability-text${atTeacher ? ' active' : ' inactive'}`}>
              {renderLocationLabel()}
            </div>
          </div>
        </div>
      )}
      {locationInHouse && (
        <div
          className={`at-home-availability-button${atHome ? ' active' : ' inactive'}${
            inHouseOnlyLocation ? ' in-house-only' : ''
          }`}
        >
          <div className='at-home-availability-icon-text-container'>
            <div className={`at-home-availability-icon-container${atHome ? ' active' : ' inactive'}`}>
              <img className='at-home-icon' alt='at home icon' src={`${AtHomeIcon}`} width={20} height={20} />
            </div>
            <div className={`at-home-availability-text${atHome ? ' active' : ' inactive'}`}>
              {I18n.t('courses.show.in_house')}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

ToggleSwitch.propTypes = {
  handleClickAtTeacher: PropTypes.func,
  handleClickAtHome: PropTypes.func,
  atHome: PropTypes.bool,
  atTeacher: PropTypes.bool
}

export default ToggleSwitch
